<template>
  <div class="container">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section section-celular">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="form">
        <b-form>
          <b-form-group>
            <b-form-input 
              id="numeroCelular"
              v-model.trim= "$v.numeroCelular.$model" 
              placeholder="Nro.Celular"
              type="text"
              :state="numeroCelularValido"
              aria-describedby="numeroCelularHelp"
              @blur.native="resetValidations">
            </b-form-input>
            <b-form-invalid-feedback id="numeroCelularFeedback">
              {{ numeroCelularInvalidoMsj }}
            </b-form-invalid-feedback>
            <!--<b-form-text id="numeroCelularHelp">Enviaremos un SMS para confirmar su participación</b-form-text>-->
          </b-form-group>
          <b-button class="link"
            @click.prevent="save">ENVIAR</b-button>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, numeric, minLength } from 'vuelidate/lib/validators';

export default {
  data () {
    return {
      evento: null,
      participante: null,

      numeroCelular: '',
      numeroCelularValido: null,
      numeroCelularInvalidoMsj: '',
    }
  },
  created () {
    if (!this.$store.getters['user/loggedIn']) {
      this.$router.push({ name: 'Login' });
    }
    /* Recuperamos la info del evento */
    var evento = this.$store.getters['eventos/evento'];
    if (evento) {
      this.evento = evento.nombre;
      /* Recuperamos la info del participante */
      var participante =  this.$store.getters['participante/participante'];
      if (participante) {
        this.participante = this.$store.getters['participante/nombreCompleto'];
      } else {
        this.$router.push({ name: 'SeleccionMetodo' });
      }
    } else {
      this.$router.push({ name: 'SeleccionEvento' });
    }
  },
  methods: {
    resetValidations() {
      this.numeroCelularValido = null;
      this.numeroCelularInvalidoMsj = '';
    },
    save () {
      this.$v.$touch();

      if (this.$v.numeroCelular.$error) {
        if (!this.$v.numeroCelular.required) {
          this.numeroCelularValido = false;
          this.numeroCelularInvalidoMsj = 'Debe ingresar el nro de celular';
          return;
        }      
        if (!this.$v.numeroCelular.numeric) {
          this.numeroCelularValido = false;
          this.numeroCelularInvalidoMsj = 'Debe ingresar sólo dígitos numéricos';
          return;
        }      
        if (!this.$v.numeroCelular.minLength) {
          this.numeroCelularValido = false;
          this.numeroCelularInvalidoMsj = 'Debe ingresar el nro completo con código de area';
          return;
        }      
      } else {
        this.numeroCelularValido = null;
        this.numeroCelularInvalidoMsj = '';
      }

      this.$store.dispatch('participante/save', this.numeroCelular)
        .then(response => {
          this.$router.push({ name: 'Confirmacion' });
        })
        .catch( error => {
          console.log(error.errorMessage);
          /*
          this.msjModalVisible= true;
          this.msjModal = error.errorMessage;
          */
        });
    },
    back () {
      this.$router.go(-1);
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    }
  },
  validations: {
    numeroCelular: {
      required,
      numeric,
      minLength: minLength(9),
    },
  },  

}
</script>

<style>
  .form-group {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/IngresoCelular.vue